let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cFLtL")).then(() => parcelRequire('avGlQ'));